import { render, staticRenderFns } from "./BulkTransactionsOverview.vue?vue&type=template&id=0ccddb43&"
import script from "./BulkTransactionsOverview.vue?vue&type=script&lang=js&"
export * from "./BulkTransactionsOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports